import React, { useState, useEffect } from "react";
//import Sidebar from "../Components/Sidebar";
import CollapsibleSidebar from "../Components/CollapsibleSidebar";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { useLocation, useNavigate } from "react-router-dom";
//import { fetchAllowedMenus } from "../Services/APIService";

// interface MenuItem {
//   menuID: number;
//   menuName: string;
//   menuUrl: string;
//   icon: string;
//   subMenuList?: [];
// }

const SuperAdminDashboard: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  // const [allowedMenus, setAllowedMenus] = useState<MenuItem[]>([]);
  // const [isLoading, setIsLoading] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  useEffect(() => {
    const getMenus = async () => {
      setIsLoading(true);
      try {
        const menuID = location.state?.menuID;
        const subMenuId = location.state?.subMenuId;
        const userDataUpdated = location.state?.userDataUpdated; // Add this

        const previousMenuID = localStorage.getItem("activeMenuID");
        if (menuID !== previousMenuID || menuID === null) {
          localStorage.setItem("activeMenuID", menuID);
        } else {
          localStorage.removeItem("activeMenuID");
        }
      } catch (error) {
        console.error("Error fetching menus:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getMenus();
  }, [location.state]);

  return (
    <div className="wrapper">
      {/* <Sidebar
        collapsed={isSidebarCollapsed}
        allowedMenus={allowedMenus}
        isLoading={isLoading}
      /> */}
      <CollapsibleSidebar></CollapsibleSidebar>
      <div className="main">
        <Navbar onToggleSidebar={toggleSidebar} />
        <main className="content">
          <h2>Welcome To Superadmin Dashboard</h2>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default SuperAdminDashboard;
